import React from 'react';
import { ArrowUpIcon, ArrowDownIcon, ArrowUpDownIcon } from './Icons';
import './TableHeader.css';

const TableHeader = ({ 
  children, 
  sortKey, 
  currentSortKey, 
  sortDirection, 
  onSort,
  sortable = true 
}) => {
  const handleClick = () => {
    if (sortable && onSort) {
      if (currentSortKey === sortKey) {
        // Toggle direction
        onSort(sortKey, sortDirection === 'asc' ? 'desc' : 'asc');
      } else {
        // New column, default to ascending
        onSort(sortKey, 'asc');
      }
    }
  };

  const getSortIcon = () => {
    if (!sortable || !sortKey) return null;
    
    if (currentSortKey === sortKey) {
      return sortDirection === 'asc' ? (
        <ArrowUpIcon className="table-header__icon" size={14} />
      ) : (
        <ArrowDownIcon className="table-header__icon" size={14} />
      );
    }
    return <ArrowUpDownIcon className="table-header__icon table-header__icon--inactive" size={14} />;
  };

  return (
    <th 
      className={`table-header ${sortable && sortKey ? 'table-header--sortable' : ''} ${currentSortKey === sortKey ? 'table-header--active' : ''}`}
      onClick={handleClick}
    >
      <div className="table-header__content">
        <span>{children}</span>
        {getSortIcon()}
      </div>
    </th>
  );
};

export default TableHeader;










